export const ROW_HEADER_WIDTH = 80
export const CELL_WIDTH = 100
export const HEADER_OFFSET = ROW_HEADER_WIDTH - 20
export const MIN_ROW_HEIGHT = 60
